import { render, staticRenderFns } from "./goodNews.vue?vue&type=template&id=d70f0a80&scoped=true&"
import script from "./goodNews.vue?vue&type=script&lang=js&"
export * from "./goodNews.vue?vue&type=script&lang=js&"
import style0 from "./goodNews.vue?vue&type=style&index=0&id=d70f0a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70f0a80",
  null
  
)

export default component.exports